<script lang="ts">
    import { onMount } from "svelte";
    import { inflect } from "../../../core/helpers/string.helper";
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";
    import type { Survey } from "../interfaces/survey-search.interface";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    let surveyList: Survey[] = [];
    let total = 0;
    let error = false;
    let processing = false;
    let processingSeznam: boolean = false;

    onMount(() => {
        processingSeznam = true;
    });

    serviceProvider.surveySearchService.listSubs.subscribe((list) => (surveyList = list));
    serviceProvider.surveySearchService.totalSubs.subscribe((number) => (total = number));
    serviceProvider.surveySearchService.errorSubs.subscribe((status) => (error = status));
    serviceProvider.surveySearchService.processingSubs.subscribe((status) => {
        processing = status;

        if (!status) {
            processingSeznam = false;
        }
    });

    const imgW = "530" // maximum img width on some viewport size
    // const imgW = "378" // optimal img width on max viewport size
</script>

{#if processingSeznam}
    <p>Načítám...</p>
{:else if surveyList && surveyList.length > 0}
    <ul class="bno-grid bno-grid--x3 bno-list--plain">
        {#each surveyList as item}
            <li class="bno-grid__tile">
                <a
                    class="dnv-survey-preview-tile"
                    href={item.url}
                >
                    <div
                        class="dnv-survey-preview-tile__header dnv-survey-preview-tile__header--plain"
                        title={item.title}
                    >
                        {#if item.image}
                            <img
                                src="{dataProvider.portalUrl}/picfit/display?url={dataProvider.portalUrl}{item.image}&w={imgW}&op=resize"
                                alt={item.title}
                            />
                        {/if}
                        <div class="dnv-survey-preview-tile__date">
                            {#if item.isPublished}
                                <span
                                    class="bno-chip bno-chip--primary bno-chip--large"
                                >
                                    <span class="bno-chip__inner">
                                        Zbývá <strong
                                            >{item.timeToUnpublish}</strong
                                        >
                                    </span>
                                </span>
                            {:else}
                                <span
                                    class="bno-chip bno-chip--secondary bno-chip--large"
                                >
                                    <span class="bno-chip__inner">
                                        Ukončeno
                                    </span>
                                </span>
                            {/if}
                        </div>
                    </div>
                    <div class="dnv-survey-preview-tile__content">
                        <h4>
                            {item.title}
                        </h4>
                        <div class="dnv-survey-preview-tile__votes">
                            <span class="dnv-survey-preview-tile__votes-icon">
                                <span
                                    class="bno-complex-icon bno-complex-icon--obna bno-complex-icon--dnv"
                                    aria-hidden="true"
                                />
                            </span>
                            <p>
                                <strong>{item.numOfEntries}</strong>
                                {inflect("respondentu", item.numOfEntries)}
                            </p>
                        </div>
                    </div>
                </a>
            </li>
        {/each}
    </ul>
{:else if error}
    <h3>Chyba</h3>
    <p>Nastala chyba.</p>
{:else if !Array.isArray(surveyList) || !surveyList.length}
    <p>Nebyly nalezeny žádné ankety.</p>
{/if}
